<template>
<div>
    <Breadcrumbs main="CRM" title="Leads" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <div class="d-flex flex-wrap" style="gap: 12px; margin-top: 20px;">
                            <div class="mini-box">
                                <p class="mini-label">Total Leads</p>
                                <h7 class="mini-value">{{ stats.total_leads }}</h7>
                            </div>
                            <div class="mini-box">
                                <p class="mini-label">Qualified</p>
                                <h7 class="mini-value">{{ stats.qualified }}</h7>
                            </div>
                            <div class="mini-box">
                                <p class="mini-label">Pending Followup</p>
                                <h7 class="mini-value">{{ stats.pending_followup }}</h7>
                            </div>
                            <div class="mini-box">
                                <p class="mini-label">Hot Leads</p>
                                <h7 class="mini-value">{{ stats.hot_leads }}</h7>
                            </div>
                        </div>
                        <div class="d-flex justify-content-start align-items-center" style="gap: 12px;">
                            <button class="btn btn-primary" type="submit" v-b-modal.modal-prevent-closing style="display: flex; gap: 12px; align-items: center; margin-top: 24px;">
                                <i class="fa fa-light fa-plus"></i>
                                <h7>Add New Lead</h7>
                            </button>
                            <button class="btn btn-secondary" type="submit" v-b-modal.modal-add-bulk-leads style="display: flex; gap: 12px; align-items: center; margin-top: 24px;">
                                <i class="fa fa-light fa-plus"></i>
                                <h7>Add Bulk Leads</h7>
                            </button>
                        </div>
                    </div>
                    <div class="card-body">
                        <b-row class="d-flex justify-content-center align-items-center">
                            <b-col xl="6" class="d-flex flex-wrap" style="gap: 20px">
                                <b-input-group style="width: 340px;">
                                    <b-form-input v-model="filter" placeholder="Type to Search" style="box-shadow: none;"></b-form-input>
                                    <b-input-group-append>
                                        <b-button @click="filter = ''">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>

                                <div style="display: flex; gap: 12px; align-items: center; color: white; background-color: #563EE0; padding: 2px 14px; max-width: fit-content; border-radius: 5px; cursor: pointer;" @click="toggleFilterShow()">
                                    <feather type="filter"></feather>
                                    <h7>Filter</h7>
                                </div>

                                <div style="display: flex; gap: 12px; align-items: center; color: white; background-color: #DC3545; padding: 2px 14px; max-width: fit-content; border-radius: 5px; cursor: pointer;" @click="clearFilter()" v-if="selectedOwner || selectedStage || selectedStatus || selectedSource || selectedLabel || filter || selectedClosureStatus">
                                    <feather type="x"></feather>
                                    <h7>Clear All</h7>
                                </div>
                            </b-col>

                            <b-col xl="6">
                                <b-form-group label-cols="3" label="Per page" class="mb-0 w-100 datatable-select">
                                    <b-form-select v-model="perPage" :options="pageOptions" style="width: 100%;"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <div class="row mt-2" v-if="filterShow">
                            <div class="col-md-12">
                                <div class="grid-container mt-sm-0">
                                   
                                    <div class="grid-item">
                                        <b-form-group label="Owner" label-for="owner-name">
                                            <b-form-select id="owner-name" v-model="selectedOwner" :options="ownerOptions">
                                                <template #first>
                                                    <b-form-select-option :value="null" disabled>
                                                        Select Owner
                                                    </b-form-select-option>
                                                </template>
                                            </b-form-select>
                                        </b-form-group>
                                    </div>

                                    <div class="grid-item">
                                        <b-form-group label="Stage" label-for="stage-name">
                                            <b-form-select id="stage-name" v-model="selectedStage" :options="stage_list">
                                                <template #first>
                                                    <b-form-select-option :value="null" disabled>
                                                        Select Stage
                                                    </b-form-select-option>
                                                </template>
                                            </b-form-select>
                                        </b-form-group>
                                    </div>
                                    <div class="grid-item">
                                        <b-form-group label="Status" label-for="status">
                                            <b-form-select id="status" v-model="selectedStatus" :options="status_list">
                                                <template #first>
                                                    <b-form-select-option :value="null" disabled>
                                                        Select Status
                                                    </b-form-select-option>
                                                </template>
                                            </b-form-select>
                                        </b-form-group>
                                    </div>
                                    <div class="grid-item">
                                        <b-form-group label="Source" label-for="source-name">
                                            <b-form-select id="source-name" v-model="selectedSource" :options="source_list">
                                                <template #first>
                                                    <b-form-select-option :value="null" disabled>
                                                        Select Source
                                                    </b-form-select-option>
                                                </template>
                                            </b-form-select>
                                        </b-form-group>
                                    </div>
                                    <div class="grid-item">
                                        <b-form-group label="Closure" label-for="closure-name">
                                            <b-form-select id="closure-name" v-model="selectedClosureStatus" :options="closure_list">
                                                <template #first>
                                                    <b-form-select-option :value="null" disabled>
                                                        Select Closure Status
                                                    </b-form-select-option>
                                                </template>
                                            </b-form-select>
                                        </b-form-group>
                                    </div>

                                </div>
                            </div>
                        </div>

     
                        <div class="row">
                            <div   :class="showActivities ? 'col-lg-9' : 'col-lg-12'"
        class="transition-layout">
                                 <div >
                                <div v-if="!loading && !error">
                                     <button
                                        v-if="!showActivities"
                                        class="mt-2 btn btn-sm btn-primary activity-toggle-btn"
                                        @click="showActivities = true"
                                    >
                                        <i class="fa fa-clock-o mr-1"></i>
                                        View Activities
                                    </button>
                                    <div class="mt-4 table-responsive datatable-vue">
                                        <b-table show-empty stacked="md" small responsive :items="items" :fields="tablefields" :filter="filter" :per-page="perPage" @filtered="onFiltered">
                                            <template #cell(index)="data">
                                                {{ (currentPage - 1) * perPage + data.index + 1 }}
                                            </template>
                                            <template #cell(name)="data">
                                                <router-link :to="{ name: 'LeadDetails', params: { id: data.item.id } }" class="text-decoration-none">
                                                    <div class="d-flex flex-column">
                                                        <h7 style="font-weight: 600;">{{ data.item.first_name }} {{ data.item.last_name }}</h7>
                                                        <small>{{data.item.phone}}</small>
                                                        <small>{{data.item.email}}</small>
                                                    </div>
                                                </router-link>

                                                
                                            </template>

                                            <template #cell(company)="data">
                                                <div style="display: flex; flex-direction: column; gap: 4px;">  
                                                    <h5 class="text-uppercase" style="font-size: 14px;">{{ data.item?.company?.name ?? 'N/A' }}</h5>
                                                    <small>{{ data.item?.company?.address }}</small>
                                                </div>
                                            </template>

                                        

                                            <template #cell(trigger)="data">
                                                <div class="d-flex flex-column">
                                                    <h7 class="text-capitalize" v-if="data.item.source">{{data.item.source}}</h7>
                                                    <small v-if="data.item.trigger_event">{{data.item.trigger_event }}</small>
                                                </div>
                                            </template>
                                            <template #cell(stage)="data">
                                                <span
                                                    class="stage-badge"
                                                    :class="`stage-${data.item.stage}`"
                                                >
                                                    {{
                                                        stage_list.find(
                                                            item => item.value === data.item.stage
                                                        )?.text
                                                    }}
                                                </span>
                                            </template>
                                            <template #cell(status)="data">
                                                <span
                                                    class="custom-status-badge"
                                                    @click="getStatus(data.item.status, data.item.id)"
                                                    :class="{ 'status-open': data.item.status === 'open', 'status-active': data.item.status === 'active', 'status-hold': data.item.status === 'hold', 'status-lost': data.item.status === 'lost', 'status-rejected': data.item.status === 'rejected', 'status-converted': data.item.status === 'converted' }"
                                                    v-b-modal.modal-status-change
                                                >
                                                    {{
                                                        status_list.find(
                                                            item => item.value === data.item.status
                                                        )?.text || 'N/A'
                                                    }}
                                                </span>
                                            </template>
                                            <template #cell(label)="data">
                                                <div v-if="data.item.label && data.item.label.length > 0" @click="addLabeltoLead(data.item)" v-b-modal.modal-prevent-closing-label>
                                                    <div v-for="label in data.item.label" :key="label.id">

                                                        <b-badge pill variant="success">{{ label?.name }}</b-badge>
                                                    </div>
                                                </div>
                                                <div v-else v-b-modal.modal-prevent-closing-label @click="addLabeltoLead(data.item)">
                                                    <b-badge pill variant="secondary">Add Label</b-badge>
                                                </div>
                                            </template>

                                            <template #cell(owner)="data">
                                                <h7 v-if=" data.item.owner">{{ data.item.owner?.full_name }}</h7>
                                            </template>

                                            <template #cell(value)="data">
                                                <h7 v-if=" data.item.pipeline_value">{{ data.item.pipeline_value}}</h7>
                                            </template>

                                           <template #cell(next_followup)="data">
                                            <span
                                                v-if="data.item.next_followup"
                                                style="min-width: 140px; display: inline-block;"
                                            >
                                                {{ data.item.next_followup
                                                    ? formatDateTime(data.item.next_followup)
                                                    : 'N/A'
                                                }}
                                            </span>
                                        </template>

                                            <template #cell(closure_status)="data">
                                                <span
                                                    class="status-badge"
                                                    :class="getClosureStatusClass(data.item.closure_status)"
                                                >
                                                    {{
                                                        closure_list.find(
                                                            item => item.value === data.item.closure_status
                                                        )?.text || 'N/A'
                                                    }}
                                                </span>
                                            </template>

                                            <template #cell(action)="data">
                                                <span style="display: flex; gap: 12px;">
                                                    <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deleteLead(data.item.id)" title="Delete"></feather>
                                                    <feather @click="editItem(data.item)" type="edit" size="20px" style="color: #568ae3; cursor: pointer;" v-b-tooltip.hover title="Edit" v-b-modal.modal-prevent-closing-edit></feather>
                                                </span>
                                            </template>
                                        </b-table>
                                    </div>
                                </div>
                                <div v-else>
                                    <div class="loader-box">
                                        <div class="loader-10"></div>
                                    </div>
                                </div>

                                <b-col class="my-1 p-0">
                                    <b-row class="mt-3">
                                        <b-col xl="12" class="d-flex flex-wrap justify-content-start align-items-center" style="gap: 8px;">
                                            <span>
                                                <!-- First Page Button (<<) -->
                                                <button class="pg-button" :disabled="currentPage === 1" @click="goToPage(1)">
                                                    <b-icon icon="chevron-double-left"></b-icon>
                                                </button>

                                                <!-- Previous Page Button (<) -->

                                                <button class="pg-button ml-2" :disabled="currentPage === 1" @click="goToPage(currentPage - 1)">
                                                    <b-icon icon="chevron-left"></b-icon>
                                                </button>
                                            </span>

                                            <span class="align-self-center">
                                                <span class="align-self-center">
                                                    <span class="d-flex align-items-center" style="gap: 6px;">
                                                        <span>Page</span>
                                                        <b-form-input v-model="pageInput" style="box-shadow: none; max-width: 40px;" @input="handlePageInput" @blur="validatePage" @keydown.enter="validatePage" :disabled="totalPages <= 1" :max="totalPages"></b-form-input>
                                                        <span>of {{ totalPages }}</span>
                                                    </span>
                                                </span>
                                            </span>

                                            <span>
                                                <!-- Next Page Button (>) -->
                                                <button class="mr-2 pg-button" :disabled="currentPage === totalPages" @click="goToPage(currentPage + 1)">
                                                    <b-icon icon="chevron-right"></b-icon>
                                                </button>

                                                <!-- Last Page Button (>>) -->
                                                <button class="pg-button" :disabled="currentPage === totalPages" @click="goToPage(totalPages)">
                                                    <b-icon icon="chevron-double-right"></b-icon>
                                                </button>
                                            </span>
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </div>
                            </div>
                            <div class="col-lg-3 " v-if="showActivities">
                                <Activities  :activities="activities"
                @close="showActivities = false" class="mt-lg-4"/>
                            </div>
                        </div>

                        
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends--> 

    <!-- Create Lead -->
    <b-modal id="modal-add-bulk-leads" size="md" ref="modal" title="Create Bulk Leads" @show="resetBulkModal" @hidden="resetBulkModal" @ok="handleBulkOk">
        <div>
            <b-badge @click="downloadTemplate" variant="primary" style="font-size: 14px; cursor: pointer;">Download Template</b-badge>
            <form ref="form" @submit.stop.prevent="handleBulkSubmit">
                <div class="row mt-3">
                    <div class="col-md-12">
                        <div class="form-group">
                            <label>Upload CSV</label>
                            <b-form-file placeholder="Choose file or drop it here..." drop-placeholder="Drop file here..." @change="uploadAttachFile"></b-form-file>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </b-modal>

    <!-- Create Lead -->
    <b-modal id="modal-prevent-closing" size="lg" ref="modal" title="Create Lead" @show="resetModal" @hidden="resetModal" @ok="handleOk">
        <form ref="form" @submit.stop.prevent="handleSubmit">
            <div class="row">
                <div class="col-md-6">
                    <b-form-group label="First Name" label-for="first-name-input" invalid-feedback="First name is required" :state="nameState">
                        <b-form-input id="first-name-input" v-model="item.first_name" :state="nameState" required></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-md-6">
                    <b-form-group label="Last Name" label-for="last-name-input" invalid-feedback="Last name is required" :state="nameState">
                        <b-form-input id="last-name-input" v-model="item.last_name" :state="nameState" required></b-form-input>
                    </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <b-form-group label="Email" label-for="email-input" invalid-feedback="Email address is required" :state="nameState">
                        <b-form-input id="email-input" v-model="item.email" :state="nameState" required></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-md-6">
                    <b-form-group label="Phone" label-for="phone-input" invalid-feedback="Phone number is required" :state="nameState">
                        <b-form-input id="phone-input" v-model="item.phone" :state="nameState"></b-form-input>
                    </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <b-form-group label="Role" label-for="role-input" invalid-feedback="Role is required" :state="nameState">
                        <b-form-input id="role-input" v-model="item.role" :state="nameState" required></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-md-6">
    <b-form-group
        invalid-feedback="Company is requited"
        :state="nameState"
    >
        <template #label>
            <div class="d-flex justify-content-between align-items-center w-100">
                <span>Company</span>

                <b-button
                    size="sm"
                    variant="primary"
                    v-b-modal.modal-create-company
                >
                    Add Company
                </b-button>
            </div>
        </template>

        <b-form-select
            id="company-name"
            v-model="item.company"
            :options="companyOptions"
            :state="nameState"
            required
        >
            <template #first>
                <b-form-select-option :value="null" disabled>
                    Select Company
                </b-form-select-option>
            </template>
        </b-form-select>
    </b-form-group>
</div>
            </div>

            <div class="row">
                <div class="col-md-6">
                    <b-form-group label="Owner" label-for="owner-name" invalid-feedback="Owner is requited" :state="nameState">
                        <b-form-select id="owner-name" v-model="item.owner" :options="ownerOptions" :state="nameState" required>
                            <template #first>
                                <b-form-select-option :value="null" disabled>
                                    Select Owner
                                </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                </div>
                <div class="col-md-6">
                    <b-form-group label="Source" label-for="owner-name">
                        <b-form-select id="owner-name" v-model="item.source" :options="source_list">
                            <template #first>
                                <b-form-select-option :value="null" disabled>
                                    Select Source
                                </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <b-form-group label="Stage" label-for="stage-name" invalid-feedback="Stage is requited" :state="nameState">
                        <b-form-select id="stage-name" v-model="item.stage" :options="stage_list" :state="nameState" required>
                            <template #first>
                                <b-form-select-option :value="null" disabled>
                                    Select Stage
                                </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                </div>
                <div class="col-md-6">
                    <b-form-group label="Status" label-for="status" invalid-feedback="Stage is requited" :state="nameState">
                        <b-form-select id="status" v-model="item.status" :options="status_list">
                            <template #first>
                                <b-form-select-option :value="null" disabled>
                                    Select Status
                                </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <b-form-group label="Trigger Event" label-for="source-input">
                        <b-form-input id="source-input" v-model="item.trigger_event"></b-form-input>
                    </b-form-group>
                </div>

                <div class="col-md-6">
                    <b-form-group label="Pipeline Value" label-for="pipeline">
                        <b-form-input id="pipeline" type="number" min="0" v-model="item.pipeline_value"></b-form-input>
                    </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <b-form-group label="Next Follow-up Date">
                        <b-form-datepicker v-model="followupDate" />
                    </b-form-group>
                </div>

                <div class="col-md-6">
                    <b-form-group label="Next Follow-up Time">
                        <b-form-timepicker v-model="followupTime" />
                    </b-form-group>
                </div>
            </div>

        </form>
    </b-modal>

    <!-- Edit Lead -->
    <b-modal id="modal-prevent-closing-edit" size="lg" ref="modal" title="Edit Lead"  @hidden="resetEditModal" @ok="handleEditOk">
        <form ref="form" @submit.stop.prevent="handleEditSubmit">
            <div class="row">
                <div class="col-md-6">
                    <b-form-group label="First Name" label-for="first-name-input" invalid-feedback="First name is required" :state="nameState">
                        <b-form-input id="first-name-input" v-model="edit_item.first_name" :state="nameState" required></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-md-6">
                    <b-form-group label="Last Name" label-for="last-name-input" invalid-feedback="Last name is required" :state="nameState">
                        <b-form-input id="last-name-input" v-model="edit_item.last_name" :state="nameState" required></b-form-input>
                    </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <b-form-group label="Email" label-for="email-input" invalid-feedback="Email address is required" :state="nameState">
                        <b-form-input id="email-input" v-model="edit_item.email" :state="nameState" required></b-form-input>
                    </b-form-group>
                </div>

                <div class="col-md-6">
                    <b-form-group label="Phone" label-for="phone-input" invalid-feedback="Phone number is required" :state="nameState">
                        <b-form-input id="phone-input" v-model="edit_item.phone" :state="nameState"></b-form-input>
                    </b-form-group>
                </div>
            </div>

            <div class="row">
                <div class="col-md-6">
                    <b-form-group label="Role" label-for="role-input" invalid-feedback="Role is required" :state="nameState">
                        <b-form-input id="role-input" v-model="edit_item.role" :state="nameState" required></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-md-6">
                    <b-form-group label="Company" label-for="company-name" invalid-feedback="Company is requited" :state="nameState">
                        <b-form-select id="company-name" v-model="edit_item.company" :options="companyOptions" :state="nameState" required>
                            <template #first>
                                <b-form-select-option :value="null" disabled>
                                    Select Company
                                </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                </div>
            </div>

            <div class="row">
                <div class="col-md-6">
                    <b-form-group label="Owner" label-for="owner-name" invalid-feedback="Owner is requited" :state="nameState">
                        <b-form-select id="owner-name" v-model="edit_item.owner" :options="ownerOptions" :state="nameState" required>
                            <template #first>
                                <b-form-select-option :value="null" disabled>
                                    Select Owner
                                </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                </div>
                <div class="col-md-6">
                    <b-form-group label="Source" label-for="owner-name">
                        <b-form-select id="owner-name" v-model="edit_item.source" :options="source_list">
                            <template #first>
                                <b-form-select-option :value="null" disabled>
                                    Select Source
                                </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <b-form-group label="Stage" label-for="stage-name" invalid-feedback="Stage is requited" :state="nameState">
                        <b-form-select id="stage-name" v-model="edit_item.stage" :options="stage_list" :state="nameState" required>
                            <template #first>
                                <b-form-select-option :value="null" disabled>
                                    Select Stage
                                </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                </div>
                <div class="col-md-6">
                    <b-form-group label="Status" label-for="status" invalid-feedback="Stage is requited" :state="nameState">
                        <b-form-select id="status" v-model="edit_item.status" :options="status_list">
                            <template #first>
                                <b-form-select-option :value="null" disabled>
                                    Select Status
                                </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <b-form-group label="Trigger Event" label-for="source-input">
                        <b-form-input id="source-input" v-model="edit_item.trigger_event"></b-form-input>
                    </b-form-group>
                </div>

                <div class="col-md-6">
                    <b-form-group label="Pipeline Value" label-for="pipeline">
                        <b-form-input id="pipeline" type="number" min="0" v-model="edit_item.pipeline_value"></b-form-input>
                    </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <b-form-group label="Next Follow-up Date">
                        <b-form-datepicker v-model="followupDate" />
                    </b-form-group>
                </div>

                <div class="col-md-6">
                    <b-form-group label="Next Follow-up Time">
                        <b-form-timepicker v-model="followupTime" />
                    </b-form-group>
                </div>
            </div>
        </form>
    </b-modal>

    <!-- Delete Modal -->
    <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this lead?</div>
    </b-modal>

    <!-- Status -->
    <b-modal id="modal-status-change" ref="modal" title="Update Lead Status" @show="resetStatusModal" @hidden="resetStatusModal" @ok="handleStatusOk">
        <form ref="form" @submit.stop.prevent="handleStatusSubmit">
            <b-form-group label="Status" label-for="name-input">
                <b-form-select v-model="statusChange" :options="status_list"></b-form-select>
            </b-form-group>
        </form>
    </b-modal>

    <!-- Company Create -->
    <b-modal id="modal-create-company" size="lg" ref="modal" title="Create Company" @show="resetCompanyModal" @hidden="resetCompanyModal" @ok="handleCompanyOk">
        <form ref="form" @submit.stop.prevent="handleCompanySubmit">
            <div class="row">
                <div class="col-md-6">
                    <b-form-group label="Company Name" label-for="name-input" invalid-feedback="Company name is required" :state="nameState">
                        <b-form-input id="name-input" v-model="company.name" :state="nameState" required></b-form-input>
                    </b-form-group>
                </div>

                <div class="col-md-6">
                    <b-form-group label="Company Abbreviation" label-for="name-input" invalid-feedback="Company abbreviation is required" :state="nameState">
                        <b-form-input id="name-input" v-model="company.abbreviation" :state="nameState" required></b-form-input>
                    </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <b-form-group label="Industry" label-for="name-input" invalid-feedback="Industry name is required" :state="nameState">
                        <b-form-input id="name-input" v-model="company.industry" :state="nameState" required></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-md-6">
                    <b-form-group label="Company Health" label-for="health-name" invalid-feedback="Company health is required" :state="nameState">
                        <b-form-select id="health-name" v-model="company.health" :options="statusOptions" :state="nameState" required>
                                <template #first>
                                <b-form-select-option :value="null" disabled>
                                    Select Company Health Status
                                </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <b-form-group label="Email" label-for="name-input" invalid-feedback="Email address is required" :state="nameState">
                        <b-form-input id="name-input" v-model="company.email" :state="nameState" required></b-form-input>
                    </b-form-group>
                </div>

                <div class="col-md-6">
                    <b-form-group label="Website" label-for="name-input" invalid-feedback="Website is required">
                        <b-form-input id="name-input" v-model="company.website"></b-form-input>
                    </b-form-group>
                </div>
            </div>
            <b-form-group label="Company Owner" label-for="owner-name" invalid-feedback="Company owner is required" :state="nameState">
                <b-form-select id="owner-name" v-model="company.owner" :options="ownerOptions" :state="nameState" required>
                        <template #first>
                        <b-form-select-option :value="null" disabled>
                            Select Owner
                        </b-form-select-option>
                    </template>
                </b-form-select>
            </b-form-group>



            <b-form-group label="Address" label-for="name-input" invalid-feedback="Company address is required" :state="nameState">
                <b-form-input id="name-input" v-model="company.address" :state="nameState" required></b-form-input>
            </b-form-group>
         

            <b-form-group label="BIN" label-for="name-input" invalid-feedback="BIN is required">
                <b-form-input id="name-input" v-model="company.bin"></b-form-input>
            </b-form-group>

            <b-form-group label="TIN" label-for="name-input" invalid-feedback="TIN is required">
                <b-form-input id="name-input" v-model="company.tin"></b-form-input>
            </b-form-group>

            
            <div class="d-flex mb-3 mt-4 justify-content-between align-items-center">
            <h6 class="mb-0">Primary Contacts</h6>

            <b-button
                variant="primary"
                size="sm"
                @click="addPrimaryContact()"
            >
                Add Contact
            </b-button>
        </div>

        <div
            v-for="(contact, index) in company.primary_contact"
            :key="index"
            class="p-3 mb-3 border rounded"
        >
            <div class="d-flex mb-3 justify-content-between align-items-center">
                <h6 class="mb-0">
                    Contact #{{ index + 1 }}
                </h6>

                <b-button
                    variant="danger"
                    size="sm"
                    @click="removePrimaryContact(index)"
                >
                    Delete
                </b-button>
            </div>

            <div class="row">
                <div class="col-md-6">
                    <b-form-group label="Name">
                        <b-form-input
                            v-model="contact.name"
                            placeholder="Enter name"
                        />
                    </b-form-group>
                </div>

                <div class="col-md-6">
                    <b-form-group label="Phone">
                        <b-form-input
                            v-model="contact.phone"
                            placeholder="Enter phone"
                        />
                    </b-form-group>
                </div>
            </div>

            <div class="row">
                <div class="col-md-6">
                    <b-form-group label="Email">
                        <b-form-input
                            v-model="contact.email"
                            type="email"
                            placeholder="Enter email"
                        />
                    </b-form-group>
                </div>

                <div class="col-md-6">
                    <b-form-group label="Designation">
                        <b-form-input
                            v-model="contact.designation"
                            placeholder="Enter designation"
                        />
                    </b-form-group>
                </div>
            </div>
        </div>
            
        </form>
    </b-modal>
</div>
</template>

<script>
import { mapState } from 'vuex';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import Multiselect from 'vue-multiselect';
import Datepicker from 'vuejs-datepicker';
import moment from "moment";
import Activities from './all-activities.vue';

export default {
    components: {
        Multiselect,
        Datepicker,
        Activities
    },

    data() {
        return {
            bulk_attachment: null,
            tablefields: [
                {
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'name',
                    label: 'Lead',
                    sortable: true
                },
                {
                    key: 'company',
                    label: 'Company',
                    sortable: true
                },
                {
                    key: 'trigger',
                    label: 'Trigger',
                    sortable: true
                },
                {
                    key: 'stage',
                    label: 'Stage',
                    sortable: true
                },
                {
                    key: 'status',
                    label: 'Status',
                    sortable: true
                },
                {
                    key: 'owner',
                    label: 'Owner',
                    sortable: true
                },
                {
                    key: 'value',
                    label: 'Value',
                    sortable: true
                },
                {
                    key: 'next_followup',
                    label: 'Next Follow-up',
                    sortable: true
                },
                {
                    key: 'closure_status',
                    label: 'Closure Status',
                    sortable: true
                },
                {
                    key: 'action',
                    label: 'Action',
                    sortable: false
                }
            ],
            item: {
                first_name: '',
                last_name: '',
                email: '',
                phone: '',
                role: '',
                company: null,
                stage: '',
                status: '',
                owner: '',
                source: '',
                trigger_event: '',
                pipeline_value: '',
                address: '',
                next_followup: null,
            },
            edit_item: {
                id: null,
                first_name: '',
                last_name: '',
                email: '',
                phone: '',
                role: '',
                company: null,
                stage: '',
                status: '',
                owner: '',
                source: '',
                trigger_event: '',
                pipeline_value: '',
                address: '',
                next_followup: null,
                contacted: null,
            },
            followupDate: null,
            followupTime: '09:00:00',
            assignedLabels: [],
            label: '',
            selected: null,
            lead_id: null,
            already_assigned_labels: [],
            delete_value: null,
            filter: null,
            filterShow: false,
            selectConnected: '',
            selectedLabel: null,
            update_lead_id: null,
            connected_list: [{
                    id: 1,
                    name: 'Yes',
                    value: 'True'
                },
                {
                    id: 2,
                    name: 'No',
                    value: 'False'
                }
            ],
            stage_list: [{
                    value: 'suspect',
                    text: 'Suspect'
                },
                {
                    value: 'qualified',
                    text: 'Qualified'
                },
                {
                    value: 'discovery',
                    text: 'Discovery'
                },
                {
                    value: 'demo',
                    text: 'Demo'
                },
                {
                    value: 'proposal',
                    text: 'Proposal'
                },
                {
                    value: 'trial',
                    text: 'Trial'
                },
                {
                    value: 'customer',
                    text: 'Customer'
                }
            ],
            status_list: [{
                    value: 'open',
                    text: 'Open'
                },
                {
                    value: 'active',
                    text: 'Active'
                },
                {
                    value: 'hold',
                    text: 'Hold'
                },
                {
                    value: 'lost',
                    text: 'Lost'
                },
                {
                    value: 'rejected',
                    text: 'Rejected'
                },
                {
                    value: 'converted',
                    text: 'Converted'
                }
            ],
            source_list: [{
                    value: 'linkedin',
                    text: 'LinkedIn'
                },
                {
                    value: 'referral',
                    text: 'Referral'
                },
                {
                    value: 'website',
                    text: 'Website'
                },
                {
                    value: 'cold_outreach',
                    text: 'Cold Outreach'
                },
                {
                    value: 'event',
                    text: 'Event'
                },
                {
                    value: 'other',
                    text: 'Other'
                }
            ],
            closure_list:[
                {
                    value:'none',
                    text:'None',
                },
                {
                    value:'pending',
                    text:'Pending',
                },
                {
                    value:'approved',
                    text:'Approved',
                },
                {
                    value:'rejected',
                    text:'Rejected',
                }

            ],
            initialLoad: true,
            totalRows: 1,
            currentPage: 1,
            perPage: 25,
            pageOptions: [25, 50, 100],
            isModifyingDate: false,
            nameState: null,
            loadingPage: false,
            pageInput: 1,
            pageInputDebounce: null,
            selectedStage: null,
            selectedStatus: null,
            selectedOwner: null,
            selectedSource: null,
            selectedClosureStatus: null,
            statusChange:'',
            company: {
                name: '',
                industry:'',
                email: '',
                website: '',
                address: '',
                bin: '',
                tin: '',
                abbreviation: '',
                health:'',
                owner:'',
                primary_contact: [
                    {
                        name: '',
                        phone: '',
                        email: '',
                        designation: ''
                    }
                ]
            },
            statusOptions: [
                {
                    id: 1,
                    value: 'excellent',
                    text: 'Excellent'
                },
                {
                    id: 2,
                    value: 'healthy',
                    text: 'Healthy'
                },
                {
                    id: 3,
                    value: 'watch',
                    text: 'Watch',
                },
                {
                    id: 4,
                    value: 'at_risk',
                    text: 'At Risk',
                }
            ],
            showActivities: true
        };
    },

    computed: {
        ...mapState({
            items: state => state.lead.lead,
            loading: state => state.lead.submitLoading,
            error: state => state.lead.submitError,
            count: state => state.lead.lead_count,
           
            companies: state => state.client.company,
            salesReps: state => state.salesRep.salesRep,
            stats: state => state.lead.lead_stats,
            activities: state => state.lead.all_lead_activities,
        }),

        totalPages() {
            return Math.ceil(this.count / this.perPage);
        },

        formattedContact() {
            return [{
                    value: '',
                    text: 'Contacted',
                    disabled: true
                },
                {
                    value: true,
                    text: 'Yes'
                },
                {
                    value: false,
                    text: 'No'
                }
            ];
        },

        formattedOptions() {
            return [{
                    value: '',
                    text: 'Select contact status',
                    disabled: true
                },
                ...this.connected_list.map(status => ({
                    value: status.value,
                    text: status.name
                }))
            ];
        },

      
        companyOptions() {
            return this.companies.map(comm => ({
                value: comm.id,
                text: comm.name
            }));
        },

        ownerOptions() {
            return this.salesReps.map(rep => ({
                value: rep.id,
                text: rep ?.user ?.full_name || 'No Name'
            }));
        },

    },

    mounted() {
        this.$store.dispatch("lead/fetchLeadStats");
        this.$store.dispatch("client/fetchCompany");
        this.$store.dispatch("salesRep/fetchSalesRep")
        this.$store.dispatch("lead/viewLeadActivities");

        const query = this.$route.query;
        this.currentPage = parseInt(query.page) || 1;
        this.pageInput = this.currentPage;
        this.perPage = parseInt(query.perPage) || 25;

        if (query.category) {
            this.selectedCategory = query.category;
        }
        if (query.stage) {
            this.selectedStage = query.stage;
        }
        if (query.status) {
            this.selectedStatus = query.status;
        }
        if (query.owner) {
            this.selectedOwner = query.owner;
        }
        if (query.source) {
            this.selectedSource = query.source;
        }
        if (query.closure_status) {
            this.selectedClosureStatus = query.closure_status;
        }
            
        if (this.selectedLabel || this.selectedStage || this.selectedStatus || this.selectedOwner || this.selectedSource || this.selectedClosureStatus || this.filter) {
            this.filterShow = true;
        }

        this.updateRouteQuery();
        this.fetchInitialUpdate();

 
    },

    watch: {
        followupDate() {
            this.updateDateTime()
        },
        followupTime() {
            this.updateDateTime()
        },
        assignedLabels: {
            handler: function (newVal, oldVal) {
                this.storeAssignedLabels(newVal);
            },
            deep: true
        },


        filter(newVal, oldVal) {
            if (!this.initialLoad) {
                this.currentPage = 1;
                this.pageInput = 1;
                this.updateRouteQuery();
                this.fetchData();
            }
        },
        selectedLabel(newVal, oldVal) {
            if (!this.initialLoad) {
                this.currentPage = 1;
                this.pageInput = 1;
                this.updateRouteQuery();
                this.fetchData();
            }
        },
        currentPage(newVal, oldVal) {
            if (this.pageInput != newVal) {
                this.pageInput = newVal;
            }
            if (!this.loadingPage && !this.initialLoad) {
                this.updateRouteQuery();
                this.fetchData();
            }
        },
        perPage(newVal, oldVal) {
            if (!this.initialLoad) {
                this.currentPage = 1;
                this.pageInput = 1;
                this.updateRouteQuery();
                this.fetchData();
            }
        },


        selectedStage(newVal, oldVal) {
            if (!this.initialLoad) {
                this.currentPage = 1;
                this.pageInput = 1;
                this.updateRouteQuery();
                this.fetchData();
            }
        },
        selectedStatus(newVal, oldVal) {
            if (!this.initialLoad) {
                this.currentPage = 1;
                this.pageInput = 1;
                this.updateRouteQuery();
                this.fetchData();
            }
        },
        selectedOwner(newVal, oldVal) {
            if (!this.initialLoad) {
                this.currentPage = 1;
                this.pageInput = 1;
                this.updateRouteQuery();
                this.fetchData();
            }
        },
        selectedSource(newVal, oldVal) {
            if (!this.initialLoad) {
                this.currentPage = 1;
                this.pageInput = 1;
                this.updateRouteQuery();
                this.fetchData();
            }
        },
        selectedClosureStatus(newVal, oldVal) {
            if (!this.initialLoad) {
                this.currentPage = 1;
                this.pageInput = 1;
                this.updateRouteQuery();
                this.fetchData();
            }
        },
    },

    methods: {
        downloadTemplate() {
            const link = document.createElement('a');
            link.href = '/leads_bulk_upload_sample.csv'; 
            link.download = 'leads_bulk_upload_template.csv';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },

        uploadAttachFile(event) {
            const file = event.target.files[0];
            if (file) {
                this.bulk_attachment = file;
            }
        },

        // resetBulkModal() {
        //     this.bulk_attachment = null;
        // },

        handleBulkOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleBulkSubmit()
        },

        handleBulkSubmit() {
            this.$store.dispatch("lead/addBulkLead", {
                attachment: this.bulk_attachment,
                perPage: this.$route.query.perPage,
                page: this.$route.query.page,
                search_term: this.filter,
                contacted: this.selectConnected,
                label: this.selectedLabel,
                stage: this.selectedStage,
                status: this.selectedStatus,
                owner: this.selectedOwner,
                source: this.selectedSource,
                closure_status: this.selectedClosureStatus
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.bulk_attachment = null
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
            this.$nextTick(() => {
                this.$bvModal.hide('modal-add-bulk-leads')
            })
        },

        getClosureStatusClass(status) {
            switch (status) {
                case 'pending':
                    return 'status-pending';

                case 'approved':
                    return 'status-approved';

                case 'rejected':
                    return 'status-rejected';

                default:
                    return 'status-none';
            }
        },
        updateRouteQuery() {
            const query = {
                page: this.currentPage,
                perPage: this.perPage
            };

            if (this.selectedLabel) {
                query.label = this.selectedLabel;
            }
            if (this.selectedStage ) {
                query.stage = this.selectedStage;
            }
            if (this.selectedStatus ) {
                query.status = this.selectedStatus;
            }
            if (this.selectedOwner ) {
                query.owner = this.selectedOwner;
            }
             if (this.selectedSource ) {
                query.source = this.selectedSource;
            }
            if(this.selectedClosureStatus){
                query.closure_status = this.selectedClosureStatus;
            }
            if (this.filter) {
                query.search_term = this.filter;
            }
          
            if (JSON.stringify(this.$route.query) !== JSON.stringify(query)) {
                this.$router.replace({
                    path: this.$route.path,
                    query
                }).catch(err => {
                    if (err.name !== 'NavigationDuplicated') {
                        throw err;
                    }
                });
            }
        },
        fetchInitialUpdate() {
            this.$store.dispatch("lead/fetchLead", {
                perPage: this.perPage,
                currentPage: this.currentPage,
                search_term: this.filter,
                contacted: this.selectConnected,
                label: this.selectedLabel,
                stage: this.selectedStage,
                status: this.selectedStatus,
                owner: this.selectedOwner,
                source: this.selectedSource,
                closure_status: this.selectedClosureStatus,


            }).then(() => {
                this.totalRows = this.count;
                this.initialLoad = false;
            });
        },

        fetchData() {
            if (!this.initialLoad) {
                this.$store.dispatch("lead/fetchLead", {
                    perPage: this.perPage,
                    currentPage: this.currentPage,
                    search_term: this.filter,
                    contacted: this.selectConnected,
                    label: this.selectedLabel,
                    stage: this.selectedStage,
                    status: this.selectedStatus,
                    owner: this.selectedOwner,
                    source: this.selectedSource,
                    closure_status: this.selectedClosureStatus,

                }).then(() => {
                    this.totalRows = this.count;
                });
            }
        },
        formatDateTime(date) {
            return new Date(date).toLocaleString('en-BD', {
                day: '2-digit',
                month: 'short',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: true
            });
        },
        updateDateTime() {
            if (this.followupDate && this.followupTime) {
                this.item.next_followup =
                    `${this.followupDate}T${this.followupTime}`
            }
        },
        checkFormValidity() {
            const valid = this.$refs.form.checkValidity()
            this.nameState = valid
            return valid
        },
        handlePageInput() {

            if (this.pageInputDebounce) {
                clearTimeout(this.pageInputDebounce);
            }

            if (!this.pageInput || this.pageInput === '') {
                return;
            }

            this.pageInputDebounce = setTimeout(() => {
                this.validatePage();
            }, 800);
        },

        validatePage() {
            this.loadingPage = true;

            // Clear debounce timer
            if (this.pageInputDebounce) {
                clearTimeout(this.pageInputDebounce);
                this.pageInputDebounce = null;
            }

            const totalPages = this.totalPages;
            let page = parseInt(this.pageInput);

            if (!page || isNaN(page) || page < 1) {
                page = 1;
            } else if (page > totalPages) {
                page = totalPages;
            }

            this.pageInput = page;
            this.currentPage = page;

            this.loadingPage = false;
        },

        goToPage(page) {
            if (page < 1 || page > this.totalPages) return;
            this.currentPage = page;
            this.pageInput = page; // Update input too
        },
        

        clearFilter() {
            this.filterShow = false,
            this.filter = null,
            this.selectedLabel = null,
            this.selectedStage = null,
            this.selectedStatus = null,
            this.selectedOwner = null,
            this.selectedSource = null,
            this.selectedClosureStatus = null,
            this.selectConnected = null
        },

        selectLabel(id) {
            this.selectedLabel = id
        },

        toggleFilterShow() {
            this.filterShow = !this.filterShow
        },

        storeAssignedLabels(assignedLabels) {
            const latestId = assignedLabels[assignedLabels.length - 1].id;

            this.$store.dispatch("lead/addLabeltoLead", {
                lead: this.lead_id,
                label_id: latestId,
                page: this.$route.query.page,
                perPage: this.$route.query.perPage,
                labelAdd_delete: true,
                search_term: this.filter,
                contacted: this.selectConnected,
                label: this.selectedLabel,
                stage: this.selectedStage,
                status: this.selectedStatus,
                owner: this.selectedOwner,
                source: this.selectedSource,
                closure_status: this.selectedClosureStatus,
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.assignedLabels = [];

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing-label')
            })
        },

        addLabeltoLead(type) {
            this.lead_id = type.id
            this.already_assigned_labels = type.label
        },

        deletetLeads(id) {
            this.$store.dispatch("lead/deleteLabelfromLead", {
                leadId: this.lead_id,
                label_id: id,
                page: this.$route.query.page,
                perPage: this.$route.query.perPage,
                search_term: this.filter,
                contacted: this.selectConnected,
                label: this.selectedLabel,
                labelAdd_delete: true,
                stage: this.selectedStage,
                status: this.selectedStatus,
                owner: this.selectedOwner,
                source: this.selectedSource,
                closure_status: this.selectedClosureStatus,
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.assignedLabels = [];

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing-label')
            })
        },

        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        addLabel() {
            if (this.label !== '') {
                this.$store.dispatch("lead/addLabel", this.label).then(response => {
                    if (response.code == 200) {
                        Swal.fire({
                            title: "Success!",
                            text: response.response,
                            icon: "success"
                        });
                        this.label = ''

                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.response,
                            icon: "error"
                        });
                    }
                })
            }
        },

        resetModal() {

            this.item = {
                first_name: '',
                last_name: '',
                email: '',
                phone: '',
                role: '',
                company: null,
                stage: '',
                status: '',
                owner: '',
                source: '',
                trigger_event: '',
                pipeline_value: '',
                address: '',
                next_followup: null,
            }
            this.followupDate = null,
                this.followupTime = '09:00:00'

        },

        handleOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleSubmit()
        },

        handleEditOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleEditSubmit()
        },

        handleSubmit() {
            if (!this.checkFormValidity()) {
                return
            }

            this.$store.dispatch("lead/addLead", {
                item: this.item,
                perPage: this.$route.query.perPage,
                page: this.$route.query.page,
                search_term: this.filter,
                contacted: this.selectConnected,
                label: this.selectedLabel,
                stage: this.selectedStage,
                status: this.selectedStatus,
                owner: this.selectedOwner,
                source: this.selectedSource,
                closure_status: this.selectedClosureStatus,
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });

                    this.resetModal()
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            // Hide the modal manually
            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing')
            })

        },

        editItem(item) {
         
            this.edit_item.id = item.id
            this.edit_item.first_name = item.first_name
            this.edit_item.last_name = item.last_name
            this.edit_item.email = item.email
            this.edit_item.phone = item.phone
            this.edit_item.role = item.role
            this.edit_item.company = item.company ? item.company.id : null
            this.edit_item.stage = item.stage
            this.edit_item.status = item.status
            this.edit_item.owner = item.owner ? item.owner.id : null
            this.edit_item.source = item.source
            this.edit_item.trigger_event = item.trigger_event
            this.edit_item.pipeline_value = item.pipeline_value

            if (item.next_followup) {
                const date = new Date(item.next_followup);
                this.followupDate = date.toISOString().split('T')[0];
                this.followupTime = date.toTimeString().split(' ')[0];
            }

        },

        resetEditModal() {
            this.edit_item = {
                id: null,
                first_name: '',
                last_name: '',
                email: '',
                phone: '',
                role: '',
                company: null,
                stage: '',
                status: '',
                owner: '',
                source: '',
                trigger_event: '',
                pipeline_value: '',
                address: '',
                next_followup: '',
                contacted: null,
            }
            // this.followupDate = null,
            // this.followupTime = '09:00:00'
        },

        handleEditSubmit() {
            if (!this.checkFormValidity()) {
                return
            }
            if (this.edit_item.next_followup !== null) {
                this.edit_item.next_followup = moment(String(this.edit_item.next_followup)).format("YYYY-MM-DD");
            }
            this.$store.dispatch("lead/updateLead", {
                item: this.edit_item,
                perPage: this.$route.query.perPage,
                page: this.$route.query.page,
                search_term: this.filter,
                contacted: this.selectConnected,
                label: this.selectedLabel,
                stage: this.selectedStage,
                status: this.selectedStatus,
                owner: this.selectedOwner,
                source: this.selectedSource,
                closure_status: this.selectedClosureStatus,
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.resetEditModal()
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            // Hide the modal manually
            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing-edit')
            })

        },

        deleteLead(id) {
            this.delete_value = id
        },

        handleDeleteOk() {
            this.$store.dispatch("lead/deleteLead", {
                item: this.delete_value,
                perPage: this.$route.query.perPage,
                page: this.$route.query.page,
                search_term: this.filter,
                contacted: this.selectConnected,
                label: this.selectedLabel,
                stage: this.selectedStage,
                status: this.selectedStatus,
                owner: this.selectedOwner,
                source: this.selectedSource,
                closure_status: this.selectedClosureStatus,
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.delete_value = null

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        },

    
        getStatus(status, id) {
            this.update_lead_id = id
            this.statusChange = status
        },

        handleStatusOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleStatusSubmit()
        },

        handleStatusSubmit() {
            this.$store.dispatch("lead/updateLeadStatus", {
                id: this.update_lead_id,
                status_for_change: this.statusChange,
                perPage: this.perPage,
                currentPage: this.currentPage,
                search_term: this.filter,
                contacted: this.selectConnected,
                label: this.selectedLabel,
                stage: this.selectedStage,
                status: this.selectedStatus,
                owner: this.selectedOwner,
                source: this.selectedSource,
                closure_status: this.selectedClosureStatus,
             

            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });

                    this.statusChange = null

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
            this.$nextTick(() => {
                this.$bvModal.hide('modal-status-change')
            })
        },

        addPrimaryContact(type) {
            this.company.primary_contact.push({
                name: '',
                phone: '',
                email: '',
                designation: ''
            });
        },

        removePrimaryContact(index) {
            this.company.primary_contact.splice(index, 1);
           
        },


        resetCompanyModal() {
            this.company.name = null
            this.company.industry = null
            this.company.email = null
            this.company.website = null
            this.company.address = null
            this.company.bin = null
            this.company.tin = null
            this.company.abbreviation = null
            this.company.health = null
            this.company.owner = null
            this.company.primary_contact = [
                    {
                        name: '',
                        phone: '',
                        email: '',
                        designation: ''
                    }
                ]
        },

        handleCompanyOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleCompanySubmit()
        },

        handleCompanySubmit() {
            if (!this.checkFormValidity()) {
                return
            }
            this.$store.dispatch("client/addCompany", {
                company: this.company,
             

            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.resetModal()

                    this.$nextTick(() => {
                        this.$bvModal.hide('modal-create-company')
                    })

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

        },
    }
};
</script>

<style scoped>

.mini-box {
    flex: 0 0 220px;
    width: 220px;
    padding: 16px 24px;
    border-radius: 8px;
    transition: 0.3s ease;
    background-color: #ffffff;
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);

}

.mini-box:hover {
    transform: translateY(-3px);
}

.mini-label {
    font-size: 14px;
    font-weight: 600;
    color: #62748e;
}

.mini-value {
    font-size: 18px;
    font-weight: 700;

}
/* Stage */
.stage-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 5px 12px;
    border-radius: 30px;
    font-size: 12px;
    font-weight: 600;
    text-transform: capitalize;
    min-width: 90px;
    letter-spacing: 0.3px;
    border: 1px solid transparent;
}

/* Stages */
.stage-suspect {
    background: #f3f4f6;
    color: #6b7280;
   
}

.stage-qualified {
    background: #dbeafe;
    color: #2563eb;
}

.stage-discovery {
    background: #ede9fe;
    color: #7c3aed;
}

.stage-demo {
    background: #cffafe;
    color: #0891b2;
}

.stage-proposal {
    background: #fef3c7;
    color: #d97706;
}

.stage-trial {
    background: #fee2e2;
    color: #dc2626;
}

.stage-customer {
    background: #dcfce7;
    color: #16a34a;
}

.status-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 5px 12px;
    border-radius: 30px;
    font-size: 12px;
    font-weight: 600;
    text-transform: capitalize;
    min-width: 90px;
    letter-spacing: 0.3px;
    border: 1px solid transparent;
}

/* None */
.status-none {
    background: #f1f3f5;
    color: #6c757d;
    border-color: #dee2e6;
}

/* Pending */
.status-pending {
    background: rgba(255, 193, 7, 0.12);
    color: #b78103;
    border-color: rgba(255, 193, 7, 0.3);
}

/* Approved */
.status-approved {
    background: rgba(25, 135, 84, 0.12);
    color: #198754;
    border-color: rgba(25, 135, 84, 0.25);
}

/* Rejected */
.status-rejected {
    background: rgba(220, 53, 69, 0.12);
    color: #dc3545;
    border-color: rgba(220, 53, 69, 0.25);
}



.custom-status-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 6px 14px;
    border-radius: 30px;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.3px;
    min-width: 90px;
    text-transform: capitalize;
    cursor: pointer;
    transition: all 0.2s ease;
    border: 1px solid transparent;
}

.custom-status-badge:hover {
    transform: translateY(-1px);
    opacity: 0.9;
}

/* Open */
.status-open {
    background: rgba(13, 110, 253, 0.12);
    color: #0d6efd;
    border-color: rgba(13, 110, 253, 0.25);
}

/* Active */
.status-active {
    background: rgba(25, 135, 84, 0.12);
    color: #198754;
    border-color: rgba(25, 135, 84, 0.25);
}

/* Hold */
.status-hold {
    background: rgba(255, 193, 7, 0.12);
    color: #b78103;
    border-color: rgba(255, 193, 7, 0.3);
}

/* Lost */
.status-lost {
    background: rgba(108, 117, 125, 0.12);
    color: #6c757d;
    border-color: rgba(108, 117, 125, 0.25);
}


/* Converted */
.status-converted {
    background: rgba(13, 202, 240, 0.12);
    color: #0dcaf0;
    border-color: rgba(13, 202, 240, 0.25);
}
</style>
